/**
 * Cross-platform blob download.
 *
 * Same shape as the observation-PDF download in `ChatScreenEnhanced`: an anchor
 * click on web, a temp file + share sheet on native. `Alert.alert` is a no-op on
 * web, so failures are surfaced through `showDialog` by the caller.
 */
import { Platform } from 'react-native';

export async function downloadBlob(blob: Blob, filename: string, shareTitle?: string): Promise<void> {
  if (Platform.OS === 'web') {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
    return;
  }

  const { documentDirectory, EncodingType, writeAsStringAsync } = await import('expo-file-system/legacy');
  const Sharing = await import('expo-sharing');

  const base64 = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Could not read the downloaded file.'));
    reader.onloadend = () => resolve((reader.result as string).split(',')[1]);
    reader.readAsDataURL(blob);
  });

  const fileUri = `${documentDirectory ?? ''}${filename}`;
  await writeAsStringAsync(fileUri, base64, { encoding: EncodingType.Base64 });

  if (await Sharing.isAvailableAsync()) {
    await Sharing.shareAsync(fileUri, {
      mimeType: 'application/pdf',
      dialogTitle: shareTitle || filename,
      UTI: 'com.adobe.pdf',
    });
  }
}
